import "bootstrap/dist/css/bootstrap.min.css";
import "normalize.css";
import "animate.css";
import "./index.css";
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/Router";
import RootContextProvider from "./context/RootContextProvider";
import Loader from "./components/loader/Loader";
import RouteLoader from "./components/loader/RouteLoader";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isRouteLoading, setIsRouteLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => setIsLoading(false), 3000);
    }
  }, [isLoading])

  if (isLoading) return <Loader isLoading={isLoading} />
  if (isRouteLoading)
    return (
      <RouteLoader
        isRouteLoading={isRouteLoading}
        setIsRouteLoading={setIsRouteLoading}
      />
    );
  return (
    <RootContextProvider
      isRouteLoading={isRouteLoading}
      setIsRouteLoading={setIsRouteLoading}
    >
      <RouterProvider router={router} />
    </RootContextProvider>
  );
}

export default App;
